import { ReactNode } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { muiTheme } from "styles/muiTheme";
import { ApiClientContextController } from "context/apiClient/apiClientContextController/ApiClientContextController";
import { CookieConsentProvider } from "context/cookieConsent";
import { CookieConsentBanner } from "components/cookieConsent";
import "@fontsource-variable/figtree/wght.css";

type RootLayoutProps = {
  children: ReactNode;
};

const RootLayout = ({ children }: RootLayoutProps) => (
  <MuiThemeProvider theme={muiTheme}>
    <CookieConsentProvider>
      <ApiClientContextController>{children}</ApiClientContextController>
      <CookieConsentBanner />
    </CookieConsentProvider>
  </MuiThemeProvider>
);

export default RootLayout;
